<template>
  <i
    v-if="computedIcon"
    class="vs-icon"
    :class="computedIcon.class"
  >{{ computedIcon.text }}</i>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
      example: 'md:get_app',
    },
  },
  computed: {
    computedIcon() {
      if (!this.icon) return null;
      const [type, value] = this.icon.split(':');

      switch (type) {
        case 'md': return { type, class: 'material-icons', text: value };
        case 'fa': return { type, class: 'fa fa-' + value };
        case 'loading': return { type, class: 'loading material-icons', text: 'sync' };
        default: return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vs-icon {
  font-size: 1em;
}
.vs-icon.loading {
  animation: rotate 1.8s infinite cubic-bezier(.66,.33,.33,.66);
  animation-direction: reverse;
}
</style>
